/**
 * The worked example page. It exists to prove the two things ADR-0016 standardizes: the app
 * consumes @thecvlb/design-system (never a parallel component set), and it builds to static
 * assets that FrontendSite publishes under the release tag. Replace this with your product UI.
 */
import { useState, type JSX } from "react";
import { Common } from "@thecvlb/design-system";

export function App(): JSX.Element {
  const [count, setCount] = useState(0);
  const release = import.meta.env.VITE_RELEASE_TAG ?? "local";

  return (
    <main className="mx-auto max-w-2xl p-8 font-sans">
      <header className="mb-8 flex items-center gap-4">
        <Common.Logo name="logo" className="h-8" />
        <h1 className="text-2xl font-semibold">template-frontend-react</h1>
      </header>

      <Common.Alert type="info" data-testid="release-alert">
        Release <code>{release}</code>, served through FrontendEdge with per-object baseline fallback.
      </Common.Alert>

      <section className="mt-8 flex items-center gap-4">
        <Common.Button color="blue" size="md" onClick={() => setCount((c) => c + 1)} dataTestId="counter">
          Clicked {count} {count === 1 ? "time" : "times"}
        </Common.Button>
        <Common.Button color="white" size="md" onClick={() => setCount(0)}>
          Reset
        </Common.Button>
      </section>
    </main>
  );
}
